
import {Component, Prop, Vue} from 'vue-property-decorator';
import User from '../../models/User';
import Destination from '../Passenger/models/Destination';
import Routes from '../../Routes';

@Component({
  components: {
      
  }
})
export default class UsersPage extends Vue {
  /*tslint:disable max-line-length*/
  newUserEmail: string = '';
  inviteUser: boolean = false;
  search: string = '';
  loading: boolean = false;
  pagination = {
    rowsPerPage: 10 // -1 for All,
  }
  
  get destinations(): Destination[] {
    if (this.$store.state.organization.organizations) {
      return this.$store.state.organization.organizations
      .find(o => o.id === this.organizationId).destinations;
    }
    return [];
  }

  get users(): User[] {
    return this.$store.state.organization.users;
  }

  get organizationId() {
    return this.$router.currentRoute.params.organizationId;
  }

  get router() {
    return this.$router;
  }

  get headers() {
    const headers = [ 
      { text: this.$t('generic.user.capitalized', 'User'), value: 'email', align: 'left', sortable: true },
      { text: this.$t('organization.destinations', 'Destinations'), value: 'placesText', align: 'left', sortable: false },
    ];
   
    return headers;
  }

    get userTableItems() {
    let tableItems = [];
    tableItems = this.users.map(u => {
      const user = { email: u.email, placesText: '', places: [] };
      if (this.destinations) {
        user.places = this.destinations
          .filter(d => u.destinationRoles.find(dr => dr.destinationId === d.id) ? true : false)
          .map(d => d.alias || d.address);

        let placeText = user.places.join(', ');
        placeText = placeText.length > 75 
          ? `${placeText.substring(0, 62)}... ${user.places.length} paikkaa` 
          : placeText;
        user.placesText = placeText;
      }
      return user;
    });
    return tableItems;
  }

  tableItemsSearch(items: Array<{ email: string, placeText: string, places: string[] }>, search: string, filter: any) {
    const searchLower = search.toLowerCase();
    return items.filter(i => {
      const places = i.places.find(p => p.toLowerCase().indexOf(searchLower) >= 0);
      const email = i.email.toLowerCase().indexOf(searchLower) >= 0;
      return places || email;
    });
  }

  handleRowCLick(user: User) {
    this.$router.push({ 
      name: Routes.organizationEditUserRoute.name,
      params: {
        userEmail: user.email,
      },
    });
  }

  createNewUser() {
    this.$router.push({ name: Routes.organizationNewUserRoute.name });
  }

  async created() {
    this.loading = true;
    const organizationId = this.$route.params.organizationId;
    await this.$store.dispatch('organization/getUsers', { params: { id: organizationId } });
    this.loading = false;
  }

}
